import { AuthenticationService } from './../../../services/authentication.service';
import {Component, OnDestroy, OnInit} from '@angular/core';
import {EmailService} from '../../../services/email.service';
import {Attachment, Email} from '../../../types/email-data.types';
import {UrlService} from '../../../services/url.service';
import {ApiClientService} from '../../../services/api-client.service';
import {Router} from '@angular/router';

@Component({
    selector: 'email-list',
    templateUrl: './email-list.component.html',
    styleUrls: ['./email-list.component.scss']
})
export class EmailListComponent implements OnInit, OnDestroy {
    emailsRefreshJob: any;

    constructor(
        public router: Router,
        public es: EmailService,
        public api: ApiClientService,
        public urlService: UrlService,
        public authenticationService: AuthenticationService
    ) {}

    ngOnInit() {
        this.emailsRefreshJob = setInterval(() => {
            if (!this.es.isWaitingForGetAllMailings) {
                for (let i = 0; i < this.es.data.entities.length; i++) {
                    if ((<any>this.es.data.entities[i]).status == 'in_progress') {
                        this.es.getAllMailings(true);
                        break;
                    }
                }
            }
        }, 30000);
    }

    orderBy(orderBy: string, $event) {
        if (this.es.data.total < 2) return;
        this.es.urlService.orderBy(orderBy, $event);
    }

    showEmailViewModal(email: Email, index) {
        if(!this.authenticationService.userIsResident) {
            const baseUrl = `/api/v1/mailings/${email.id}.json?expand=attachments`;
            this.api.get('domainEmails', baseUrl).subscribe(
                res => {
                    const data = JSON.parse(res._body);
                    const body = this.es.mailingsFactoryCreate(data);
                    if(body.status != 'draft' && body.status != 'scheduled') {
                        this.es.emailInViewModal = body;
                        this.es.isEmailViewModalShow = true;
                    } else {
                        this.es.emailInComposePage = body;
                        this.router.navigateByUrl('/email-merge/compose');
                    }
                },
                error => {
                    this.api.errorHandler(error, 'Failed get Email');
                }
            );
        } else {
            const url = `/v1/messages/${email.id}.json`;
            this.api.get('domainNotifications', url).subscribe( res => {
                const body = JSON.parse(res._body);
                this.es.emailInViewModal = new Email();
                this.es.emailInViewModal.id = body.id;
                this.es.emailInViewModal.subject = body.subject;
                this.es.emailInViewModal.message = body.bodyHtml;
                this.es.emailInViewModal.createdAt = body.createdAt;
                this.es.emailInViewModal.attachments = body.attachments.map(
                                at => new Attachment(at.filename, at.fileSize, at.path)
                            );
                this.es.isEmailViewModalShow = true;
                this.api.patch('domainNotifications', url, {read: 1}).subscribe(
                    res => (<any>this.es.data.entities[index]).readAt = new Date().toISOString()
                );
            } , error =>  this.api.errorHandler(error, 'Failed get Message'));
        }
    }

    dateIsLaterThanParticularOtherDate(date) {
        return date && new Date(date) > new Date(2019, 9, 1);
    }

    ngOnDestroy() {
        clearInterval(this.emailsRefreshJob);
    }
}



// WEBPACK FOOTER //
// /app/src/app/views/email/email-list/email-list.component.ts